module.exports = __webpack_public_path__ + "static/media/logo.6839bc96.png";